import app from '../../helpers/app';
import {
    closeMobileSidebar,
    openMobileSidebar,
    setDarkTheme,
    setDesktopBigSidebarSize,
    setDesktopSmallSidebarSize,
    setLightTheme,
    toggleDesktopSidebarSize,
    toggleMobileSidebar
} from '../../_redux/theme/actions';
import {ITheme} from '../../@interfaces/services/Theme/ITheme';

export default class Theme implements ITheme {
    activeThemeIsDark(): boolean {
        return document?.body?.classList.contains('dark-theme') === true;
    }

    activeThemeIsLight(): boolean {
        return !this.activeThemeIsDark();
    }

    setDarkTheme(): void {
        app().dispatchAction(setDarkTheme());
    }

    setLightTheme(): void {
        app().dispatchAction(setLightTheme());
    }

    toggleTheme(): void {
        if (this.activeThemeIsDark()) {
            this.setLightTheme();
        } else {
            this.setDarkTheme();
        }
    }

    setDesktopSidebarSmallSize(): void {
        app().dispatchAction(setDesktopSmallSidebarSize());
    }

    setDesktopSidebarBigSize(): void {
        app().dispatchAction(setDesktopBigSidebarSize());
    }

    toggleDesktopSidebarSize(): void {
        app().dispatchAction(toggleDesktopSidebarSize());
    }

    openMobileSidebar(): void {
        app().dispatchAction(openMobileSidebar());
    }

    closeMobileSidebar(): void {
        app().dispatchAction(closeMobileSidebar());
    }

    toggleMobileSidebar(): void {
        app().dispatchAction(toggleMobileSidebar());
    }
}
